import React from 'react'
import Info from './Info'
import Pic from './Pic'
import Product from './Products'
import './Navbar.css'
const Body = ({onAdd, Products, plus, minus, count}) => {
  return (
    <div>
   <section class=" p-5 p-lg-0 pt-lg-5 text-center text-sm-start">
    <div class="container">
     <div class="space">
     <div class="illustartion">
           <Pic slides={Product}/> 
           </div>
        <div class="box p-4">
        {Products.map ((product) => (
<Info key = {product.id}
onAdd={onAdd}
count = {count}
plus = {plus}
minus = {minus}
product = {product}/>))}
       </div>
       
    </div>
    </div>
</section> 
    </div>
  )
}

export default Body